import { Box, TableContainer } from '@mui/material';
import { css, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 30px 30px 30px;
  gap: 20px;
  width: 100%;
  background: #f5f5f5;
  overflow-y: auto;
`;

export const Header = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-top: 30px;
`;

export const Title = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  color: #000000;
`;

export const Filters = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 20px;

  width: 100%;
  height: 48px;
`;

export const Table = styled(Box)`
  width: 100%;
`;

export const TableContainerStyles = styled(TableContainer)`
  max-height: 100vh;
  /* max-height: 65vh;
  

  @media (max-height: 948px) {
    max-height: 60vh;
  }

  @media (max-height: 853px) {
    max-height: 55vh;
  }

  @media (max-height: 756px) {
    max-height: 50vh;
  }

  @media (max-height: 677px) {
    max-height: 40vh;
  }

  @media (max-height: 564px) {
    max-height: 30vh;
  } */
`;
